module.exports = __webpack_public_path__ + "static/media/stem-sprite.6d5eab02.png";